/* eslint-disable react/no-unescaped-entities */
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import Seo from '../Seo';
import { CONTACT_EMAIL, PAGE_SEO, SITE_NAME, SITE_URL } from '../../utils/seo';
import '../PrivacyPolicy/index.css';

export default function TermsOfService() {
  return (
    <Row style={{ display: 'flex', justifyContent: 'center', margin: '20px' }}>
      <Seo
        title={PAGE_SEO.TERMS.title}
        description={PAGE_SEO.TERMS.description}
        canonical={`${SITE_URL}/terms`}
      />
      <Col span={18} md={18} xs={24}>
        <h1 className="card-category text-gray title-name">Terms of Service</h1>
        <p className="date-display">Last updated: August 14, 2026</p>

        <p className="des-para">
          These Terms of Service (“Terms”) govern your access to and use of {SITE_NAME} at {SITE_URL}
          (the “Service”). By using the Service, you agree to these Terms and to our{' '}
          <Link to="/privacy-policy">Privacy Policy</Link> and <Link to="/dmca">DMCA Policy</Link>.
        </p>

        <h2>1. The Service</h2>
        <p className="des-para">
          Koostream provides sports information: fixture lists, schedules, standings, and original
          editorial commentary. We do not claim to be an official broadcaster, league, or team. We do
          not host copyrighted television or streaming broadcasts of professional sports. Licensed
          live coverage is available only from official rights holders and their authorized partners.
        </p>

        <h2>2. Intellectual property</h2>
        <p className="des-para">
          Original text, layout, and original graphics on this website are owned by Koostream or its
          licensors and are protected by copyright. You may not copy, scrape, or republish our
          editorial content without permission, except as allowed by fair use or similar exceptions.
        </p>
        <p className="des-para">
          Third-party names, logos, and trademarks (including leagues, clubs, and athletes) remain the
          property of their owners. They appear only to identify events and for news reporting.
        </p>
        <p className="des-para">
          If you believe content on the Service infringes your copyright, follow the process in our{' '}
          <Link to="/dmca">DMCA Policy</Link>.
        </p>

        <h2>3. Third-party links and user submissions</h2>
        <p className="des-para">
          The Service may display links submitted by users or retrieved from third-party sources. Those
          links are not hosted, verified, or controlled by Koostream. We do not warrant that any
          third-party website is lawful, accurate, or safe. Accessing third-party sites is at your
          own risk. If a link points to unauthorized copyrighted material, we will remove it upon a
          valid DMCA notice.
        </p>
        <p className="des-para">
          You may not submit, post, or request links to content that you do not have the right to
          share, including unauthorized broadcasts. Submissions that violate copyright, trademark, or
          other laws may be removed without notice, and repeat violators may be blocked.
        </p>

        <h2>4. Acceptable use</h2>
        <p className="des-para">You agree not to:</p>
        <ul>
          <li>Use the Service to infringe copyright, trademark, or other intellectual property rights.</li>
          <li>Attempt to disrupt, scrape at abusive volume, or reverse engineer the Service.</li>
          <li>Submit malware, spam, or fraudulent content.</li>
          <li>Misrepresent affiliation with Koostream, a league, or a broadcaster.</li>
        </ul>

        <h2>5. No official partnership</h2>
        <p className="des-para">
          Koostream is an independent website. We are not affiliated with, endorsed by, or sponsored
          by FIFA, UEFA, the Premier League, NFL, NBA, NHL, MLB, UFC, Formula 1, or any other league,
          team, or broadcaster unless we expressly say so in writing.
        </p>

        <h2>6. Disclaimers</h2>
        <p className="des-para">
          The Service is provided “as is.” Fixture times, scores, and standings may be delayed or
          incorrect. Editorial opinions are those of the authors and are not statements of fact about
          third parties beyond publicly reported events. We disclaim warranties of merchantability,
          fitness for a particular purpose, and non-infringement to the fullest extent permitted by
          law.
        </p>

        <h2>7. Limitation of liability</h2>
        <p className="des-para">
          To the fullest extent permitted by law, Koostream and its operators are not liable for
          indirect, incidental, special, consequential, or punitive damages, or for any loss of data,
          profits, or goodwill arising from your use of the Service or from third-party websites
          reached through the Service.
        </p>

        <h2>8. Indemnity</h2>
        <p className="des-para">
          You agree to indemnify and hold Koostream harmless from claims arising out of your use of
          the Service, your submissions, or your violation of these Terms or of any law.
        </p>

        <h2>9. Changes</h2>
        <p className="des-para">
          We may update these Terms from time to time. The “Last updated” date at the top of this page
          will change when we do. Continued use after changes constitutes acceptance.
        </p>

        <h2>10. Contact</h2>
        <p className="des-para">
          Questions about these Terms: {CONTACT_EMAIL} or our <Link to="/contact-us">contact form</Link>.
        </p>
      </Col>
    </Row>
  );
}
